module.exports = flarum.core.compat['components/DiscussionListItem'];